import { render, staticRenderFns } from "./otherFee.vue?vue&type=template&id=c7b97562&scoped=true&"
import script from "./otherFee.vue?vue&type=script&lang=js&"
export * from "./otherFee.vue?vue&type=script&lang=js&"
import style0 from "./otherFee.vue?vue&type=style&index=0&id=c7b97562&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b97562",
  null
  
)

export default component.exports